// extracted by mini-css-extract-plugin
export default {"main":"Hospitals_main__30Noz","hospitalsList":"Hospitals_hospitalsList__-1XDH"};